import React from "react";
import SearchList from "../CustomRowComponents/SearchList";
import ClaimsSearchResult from "../CustomRowComponents/ClaimsSearchResult";
export const ListOptions = (
  defaultIndex,
  pagination,
  isLoading,
  sort,
  count,
  page,
  handleOnColumnSortChange,
  handleTableChange,
  rowsPerPageOptions,
) => {
  return {
    hasIndex: true,
    indexColumn: defaultIndex,
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    search: false,
    selectableRows: "none",
    serverSide: true,
    count: count,
    page: page,
    pagination: pagination ?  count > 10 : pagination,
    sort: sort,
    responsive: "simple",
    fixedHeader: true,
    rowsPerPageOptions: rowsPerPageOptions ? rowsPerPageOptions : [10, 20, 30],
    textLabels: {
      body: {
        noMatch: isLoading ? "Fetching Records ..." : "No data available ",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort by ${column.label}`,
      },
    },
    onColumnSortChange: (changedColumn, direction) => {
      handleOnColumnSortChange(changedColumn, direction);
    },
    onTableChange: (action, tableState) => {
      handleTableChange(action, tableState);
    },
  };
};

export const CustomRowRender = (
  defaultIndex,
  pagination,
  isLoading,
  sort,
  count,
  page,
  handleOnColumnSortChange,
  handleTableChange,
  history,
  defaultSearchValue,
  defaultSearchColumn,
  handleWarnings
) => {
  return {
    hasIndex: true,
    indexColumn: defaultIndex,
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    search: false,
    selectableRows: "none",
    serverSide: true,
    count: count,
    page: page,
    pagination: pagination ? count > 10 : pagination,
    sort: sort,
    responsive: "simple",
    fixedHeader: true,
    rowsPerPageOptions: [10, 20, 30],
    textLabels: {
      body: {
        noMatch: isLoading ? "Fetching Records ..." : "No data available ",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort by ${column.label}`,
      },
    },
    onColumnSortChange: (changedColumn, direction) => {
      handleOnColumnSortChange(changedColumn, direction);
    },
    customRowRender: (data) => {
      return defaultSearchColumn === "claimNo" ||
        defaultSearchColumn === "claimantName" ||
        (localStorage.getItem("searchElement") === "policyNo" &&
          localStorage.getItem("URL") === "claim/csr") ? (
        <ClaimsSearchResult
          history={history}
          key={data}
          data={data}
          defaultSearchValue={defaultSearchValue}
          handleWarnings={handleWarnings}
        />
      ) : (
        <SearchList
          history={history}
          key={data[0]}
          data={data}
          defaultSearchValue={defaultSearchValue}
        />
      );
    },
    onTableChange: (action, tableState) => {
      handleTableChange(action, tableState);
    },
  };
};
